import {useCallback, useEffect, useMemo, useState} from "react";
import dataProvider from "../../providers/data-provider";
import { Datagrid, ListContextProvider, TextField, useList } from "react-admin";
import { StatusField } from "../../components/forms/status-field";
import { Alert } from "@material-ui/lab";

export function ListMyRequests(props) {
    const [data, setData] = useState([]);

    useEffect(() => {
        dataProvider.get('formsRequest', 'my-request').then(res => setData(res.data ?? []))
    }, []);

    const ids = useMemo(() => data.map(w => w.id), [data]);

    const listContext = useList({
        data,
        ids,
        basePath: '/formsRequest',
        resource: 'formsRequest',
        page: 1,
        loaded: true
    });


  const onEdit = useCallback((id) => {
    const record = data.find(w => w.id === id);
    if (record.status !== 'opened') return;
    props.onEdit(record);
  }, [data, props.onEdit])

  if (!data.length) {
    return (
      <Alert variant={"standard"} severity={'info'}>
          Não há requisições pendentes no momento
      </Alert>
    )
  }

  return (
    <ListContextProvider value={listContext}>
      <Datagrid rowClick={onEdit}>
        <TextField source="availability.form.name" label={'Formulário'} />
        <TextField source="availability.form.description" label={'Descrição'} />
        <TextField source="observation" label={'Observação'} />
        <StatusField source="status" />
      </Datagrid>
    </ListContextProvider>
  )
}